import { ControlType, Property, PropertyType } from "../../../base/types";
import { FC, useEffect, useState } from "react";

import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import clsx from "clsx";
import { useAuth } from "../../../../modules/auth";
import { useDownloadDocument } from "../../../services/data/sharepoint";
import { useGetProperties } from "../../../base/hooks";
import { useLazyGetSiteQuery } from "../../../services/auth";

export const ImageComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const tooltip: string | undefined = properties[Property.Tooltip];
    const url: string | undefined = properties[Property.Url];
    const altText: string | undefined = properties[Property.AltText];

    const { siteId } = useAuth();
    const [getSite, { data: site }] = useLazyGetSiteQuery();

    useEffect(() => {
        if (!siteId) return;
        getSite(siteId)
        // eslint-disable-next-line
    }, [siteId])

    if (url && site && site.imageGallery && url.toLowerCase().startsWith(site.imageGallery?.toLocaleLowerCase()))
        return <SPImage altText={altText} url={url} tooltip={tooltip} className={className} />

    return (
        <div className={clsx(className, "overflow-hidden")}>
            <img alt={altText} className="w-100"
                style={{ objectFit: "cover", objectPosition: "top" }}
                src={url} title={tooltip} />
        </div>
    )
}

const SPImage = ({ altText, url, tooltip, className }: {
    altText?: string,
    url: string,
    tooltip?: string,
    className?: string
}) => {
    const { getBase64Url } = useDownloadDocument();
    const [base64, setBase64] = useState<string>()

    useEffect(() => {
        getBase64Url(url)
            .then((base64) => setBase64(base64))
        // eslint-disable-next-line
    }, [url])

    return (
        <img alt={altText}
            style={{ objectFit: "cover", objectPosition: "top" }}
            className={clsx(className, "img-fluid mx-auto d-block")}
            src={base64}
            title={tooltip} />
    )
}

Registry.addControl({
    id: "441e3c90-fae6-449d-a27b-70bda9abf63b",
    name: "Image",
    type: ControlType.Image,
    properties: [
        { id: Property.AltText, name: 'Alternate text', type: PropertyType.String },
        { id: Property.Url, name: 'Url', type: PropertyType.Url },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String }
    ],
    component: ImageComponent
})
